// JobPost Styles:

import styled from 'styled-components'

import { Box, Flex, Heading } from '@/components/elements'

import theme from '../../../config/theme'

export const JobPost = styled(Box)`
  flex-wrap: wrap;
  width: 100%;

  @media ${theme.mq.tablet} {
  }
`
